import { Fragment, useState } from "react";
import { observer } from "mobx-react";
import { Typography, Tooltip, IconButton } from "@material-ui/core";
import { ContentCopy } from "mdi-material-ui";
import { TokenizedStrings } from "../../../data/strings/buttons";
import SuccessSnackbar from "../SuccessSnackbar";

interface CopyTextButtonProps {
    title?: string;
    onClicked?: () => void;
}

const CopyTextButton = observer((props: CopyTextButtonProps) => {

    /***** State *****/

    const [snackbarOpen, setSnackbarOpen] = useState(false);

    /***** Event handlers *****/

    const onButtonClicked = () => {
        if (props.onClicked) {
            props.onClicked();
        }
        setSnackbarOpen(true);
    }

    /***** Render *****/

    return (
        <Fragment>
            <Tooltip
                arrow
                leaveTouchDelay={15000}
                interactive
                title={
                    <Typography style={{ textAlign: 'center' }}>
                        {props.title !== undefined ? props.title : TokenizedStrings.CopyText.english}
                    </Typography>
                }>
                <IconButton onClick={onButtonClicked}>
                    <ContentCopy fontSize="small" />
                </IconButton>
            </Tooltip>
            <SuccessSnackbar
                open={snackbarOpen}
                message={'Copied!'}
                onClose={() => setSnackbarOpen(false)}
            />
        </Fragment>
    );
});

export default CopyTextButton;